import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  useEffect(() => {
    const handleClick = (event) => {
      const target = event.target.closest("a, button");
      if (target) {
        const href = target.getAttribute("href");

        if (href && href === pathname) {
          event.preventDefault();
          navigate(pathname, { replace: true });
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [pathname, navigate]);

  return null;
};

export default ScrollToTop;
